import React, { Fragment } from "react";
import {
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  Row,
  Alert,
} from "reactstrap";
import { H1, H5 } from "../../AbstractElements";

const ComingSoon = () => {
  return (
    <Fragment>
      <Container fluid={true}>
        <div>
          <Row>
            <Col sm="12">
              <Card>
                <CardHeader>
                  <H5>{"Coming Soon"}</H5>
                  <span>Coming Soon</span>
                </CardHeader>
                <CardBody>
                  <H1>
                    <Alert color="warning">
                      This page is under development
                    </Alert>
                  </H1>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      </Container>
    </Fragment>
  );
};
export default ComingSoon;
